var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenColorStarBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.909,
    height: 15.041,
    viewBox: "0 0 15.909 15.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58303",
    "data-name": "Group 58303",
    transform: "translate(-419.568 -197.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42189",
    "data-name": "Path 42189",
    d: "M12.69,15V26.847L7.46,29l-5.23-2.153V15m12.684,0H.006m2.225,2.33H12.69",
    transform: "translate(420.063 183)",
    fill: "#00b248",
    stroke: "#1b2737",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42190_-_Outline",
    "data-name": "Path 42190 - Outline",
    d: "M186.41,198.51h-1.043a1.156,1.156,0,0,1-1-.583l-.525-.919-.525.919a1.156,1.156,0,0,1-1,.583h-1.043l.53.929a1.156,1.156,0,0,1,0,1.146l-.53.929h1.043a1.156,1.156,0,0,1,1,.583l.525.919.525-.919a1.156,1.156,0,0,1,1-.583h1.043l-.53-.929a1.156,1.156,0,0,1,0-1.146Z",
    transform: "translate(243.633 5.581)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenColorStarBadge);
export default __webpack_public_path__ + "static/media/greenColorStarBadge.295f22f175efdd9a8c8aa7aac39afee8.svg";
export { ForwardRef as ReactComponent };